var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.13147 4.575H12.2131V0H8.56776C4.17081 0.1875 3.26888 2.6625 3.19371 5.25V7.5375H0.187256V12H3.19371V24H7.7034V12H11.4239L12.1379 7.5375H7.7034V6.15C7.67904 5.75107 7.81677 5.35918 8.08548 5.06281C8.3542 4.76644 8.73125 4.5906 9.13147 4.575Z","fill":"#9D4DBD"}));
}

Facebook.defaultProps = {"width":"13","height":"24","viewBox":"0 0 13 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
